import Tooltip from "app/common/Tooltip";
import React from "react";

type IconProps = {
  show: boolean;
  toolTipText: string;
  callBack: () => void;
  position: string;
};

export const EditIcon: React.FC<IconProps> = ({ show, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={props.callBack}
          tabIndex={0}
          onKeyUp={(event) => {
            if (event.keyCode === 13) {
              props.callBack();
            }
          }}
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M8.76 18.323c.1-.1-.778-.686-.877-.786L5.037 14.9v.24L3.723 20.68l5.531-1.286-.494-1.07zM9.833 20.8l-6.949 1.615a.75.75 0 0 1-.9-.904l1.642-6.922a.75.75 0 0 1 .2-.358L15.578 2.48a1.763 1.763 0 0 1 2.488 0l3.868 3.868a1.762 1.762 0 0 1 0 2.487l-11.64 11.642a.739.739 0 0 1-.461.323z"
              fill="#000"
            />
            <path
              d="M13.043 6.73a.75.75 0 0 1 1.06-1.06l4.653 4.653a.75.75 0 0 1-1.06 1.06l-4.653-4.652z"
              className="no-fill"
              fill="#FFF"
            />
            <path
              d="M4.834 15.147a.75.75 0 1 1 1.06-1.06l4.457 4.456a.75.75 0 1 1-1.06 1.06l-4.457-4.456z"
              fill="#000"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);

export const SaveIcon: React.FC<IconProps> = ({ show, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="top">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={props.callBack}
          tabIndex={0}
          onKeyUp={(event) => {
            if (event.keyCode === 13) {
              props.callBack();
            }
          }}
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M13.043 6.73a.75.75 0 0 1 1.06-1.06l4.653 4.653a.75.75 0 0 1-1.06 1.06l-4.653-4.652z"
              fill="#FFF"
              className="no-fill"
              fillRule="nonzero"
            />
            <path
              d="M2 2c9.06-.633 14.635.184 16.724 2.45 2.089 2.267 3.133 8.019 3.133 17.256l-19.016.728L2 2z"
              fill="#000"
            />
            <path
              d="M14.923.967a.75.75 0 0 1 .51.201l6.316 5.87a.75.75 0 0 1 .24.55v13.715c0 .69-.562 1.251-1.252 1.251H3.102a1.134 1.134 0 0 1-1.135-1.133V1.967a1 1 0 0 1 1-1h11.956zm-6.906 1.5h-4.55v18.587h2.814l.001-7.755a.75.75 0 0 1 .75-.75h10.219a.75.75 0 0 1 .75.75v7.754l2.488.001V7.914L15.63 3.4v4.296a.75.75 0 0 1-.75.75H8.769a.75.75 0 0 1-.75-.75V2.466zm8.484 11.582H7.782v7.005h8.719V14.05zm-2.006 4.254a.75.75 0 0 1 0 1.5H9.789a.75.75 0 1 1 0-1.5h4.706zm0-3.004a.75.75 0 0 1 0 1.5H9.789a.75.75 0 1 1 0-1.5h4.706zm-.363-12.832H9.518v4.478h4.614V2.467z"
              className="no-fill"
              fill="#FFF"
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);
export const CancelIcon: React.FC<IconProps> = ({ show, ...props }) => (
  <React.Fragment>
    {show && (
      <Tooltip title={props.toolTipText} placement="bottom">
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          onClick={props.callBack}
          tabIndex={0}
          onKeyUp={(event) => {
            if (event.keyCode === 13) {
              props.callBack();
            }
          }}
        >
          <g fill="none" fillRule="evenodd">
            <circle fill="#000" cx="12" cy="12" r="12" />
            <path
              className="no-fill"
              d="m15.68 9.479-2.52 2.533 2.533 2.548a.75.75 0 0 1 .07.977l-.073.084a.75.75 0 0 1-1.06-.003l-2.528-2.543-2.526 2.543a.75.75 0 1 1-1.064-1.058l2.532-2.548L8.526 9.48c-.681-.685.287-1.694.99-1.125l.073.067 2.514 2.527 2.513-2.527c.705-.709 1.769.349 1.064 1.058z"
              fill="#FFF"
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Tooltip>
    )}
  </React.Fragment>
);

// const EditLine: React.FC<any> = ({ actions }) => {
//   return (
//     <React.Fragment>
//       {actions && (
//         <div className="icons">
//           <div className="leftPanel">
//             <EditIcon {...actions.pencil} />
//             <div className="innerLeftPanel">
//               <div className="saveIcon">
//                 <SaveIcon {...actions.save} />
//               </div>
//               <div className="cancelIcon">
//                 <CancelIcon {...actions.cancel} />
//               </div>
//             </div>
//           </div>
//           <div className="rightPanel">
//             <ShareIcon {...actions.share} />
//             <AssignIcon {...actions.assign} />
//           </div>
//         </div>
//       )}
//     </React.Fragment>
//   )
// }

// export default EditLine
